import * as types from '../mutation-types';
import config from '@/config';
import { loadDataForSnapshot } from '@/utils/loading';


const state = {
  paidSubscription: null,
};

const mutations = {
  [types.SET_PAID_SUBSCRIPTION]: (state, paidSubscription) => {
    state.paidSubscription = paidSubscription;
  },
};

const getters = {
  getAllowedArgumentsCount: state => state.paidSubscription.parameters.arguments,
  getAllowedRecordsCount: state => state.paidSubscription.parameters.records,
  hasReachedMaxArgumentCount: (state, getters, rootState, rootGetters) => getters.getAllowedArgumentsCount <= rootGetters.getLoggingEnabledVars.length && !state.paidSubscription.has_trial_period,
};

const actions = {
  async loadPaidSubscription({ commit, rootState }) {
    return loadDataForSnapshot(commit, rootState, types.SET_PAID_SUBSCRIPTION, config.ICOOL.API.PAID_SUBSCRIPTION_PATH);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
